<template>
	<commission-payout :isRummyOptionSelected="true" />
</template>

<script>
import CommissionPayout from "../CommissionPayout";
export default {
	components: {
		"commission-payout": CommissionPayout
	}
};
</script>
